import { useNavigate } from "react-router-dom"

const TeamTag = ({team, tag})=>{
    const navigate = useNavigate();
    const redirectToPlantillaScreen = (e)=>{
        e.stopPropagation()
        if(team.jugadores?.length > 0) return navigate(`/plantillaTeam/${team?._id}`)
    }
    return(
                <div className={`math-card-container-body-${tag}-team`} onClick={e => redirectToPlantillaScreen(e)}>
                    <img className="match-card-logo-img" src={team?.pictureTeam} />
                    <p className="match-card-team-name" > {team?.name}</p>
                </div>
    )
}

export default TeamTag